import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M17.518 10.57c.703.467 1.055.7 1.178.996.107.257.108.547.002.805-.122.296-.473.53-1.174 1l-7.905 5.294c-.85.57-1.276.855-1.628.834a1.052 1.052 0 0 1-.778-.415C7 18.802 7 18.291 7 17.267V6.727c0-1.02 0-1.529.213-1.81.185-.245.468-.397.775-.416.352-.021.776.26 1.625.824l7.905 5.246Z"
    />
  </svg>
`;
